import { Link } from "react-router-dom";
import eridonLogo from "@/assets/eridon-logo.png";

/**
 * Юридический футер ERIDON.
 * Содержит реквизиты ИП (требование ФЗ-152, ОКВЭД 62.01),
 * ссылки на оферту и политику обработки ПДн, контакты и копирайт.
 */
export function SiteFooter() {
  return (
    <footer
      className="relative z-10 border-t border-border/30 bg-secondary/20 px-4 py-10 sm:px-6"
      style={{ fontFamily: "Inter, system-ui, sans-serif" }}
    >
      <div className="mx-auto max-w-6xl space-y-8">
        {/* Top grid */}
        <div className="grid gap-8 text-sm sm:grid-cols-2 lg:grid-cols-3">
          {/* Brand */}
          <div>
            <div className="mb-3 flex items-center gap-2">
              <img
                src={eridonLogo}
                alt="ERIDON логотип"
                width={28}
                height={28}
                className="h-7 w-7 shrink-0"
                loading="lazy"
              />
              <span className="font-bold tracking-wide text-foreground">ERIDON</span>
            </div>
            <p className="text-xs leading-relaxed text-muted-foreground">
              ИИ-автоматизация маркировки интернет-рекламы. Соответствие ФЗ-347, ФЗ-168 и ФЗ-152.
            </p>

            {/* Соцсети */}
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://vk.com/eridonai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-lg border border-border/40 bg-background/40 text-muted-foreground transition-colors hover:text-primary"
                aria-label="ERIDON ВКонтакте"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12.785 16.241s.288-.032.436-.194c.136-.148.132-.427.132-.427s-.02-1.304.587-1.496c.596-.19 1.364 1.26 2.178 1.816.615.42 1.082.328 1.082.328s2.175-.03 2.175-.03 1.14-.07.599-.964c-.044-.073-.316-.661-1.623-1.869-1.37-1.264-1.187-1.06.463-3.248.805-1.065 1.326-2.033 1.27-2.32 0 0-.17-.443-1.218-.443H17.27s-.23-.032-.4.07c-.168.1-.276.332-.276.332s-.495 1.318-1.155 2.44c-1.394 2.369-1.952 2.494-2.18 2.348-.53-.34-.398-1.366-.398-2.094 0-2.277.345-3.226-.672-3.472-.337-.081-.585-.135-1.448-.143-.928-.01-1.905.003-2.399.245 0 0-.499.33-.177.345.266.012.707.066.968.5.336.56.324 1.82.324 1.82s.193 2.68-.45 3.013c-.442.228-1.047-.238-2.349-2.374-.665-1.094-1.17-2.303-1.17-2.303s-.097-.237-.27-.364c-.21-.154-.503-.203-.503-.203L3.2 7.008s-.348.01-.476.16c-.114.135-.009.413-.009.413s2.324 5.435 4.956 8.174c2.413 2.51 5.153 2.346 5.153 2.346h1.243l.01-.057z"/></svg>
              </a>
              <a
                href="https://t.me/eridonai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-8 w-8 items-center justify-center rounded-lg border border-border/40 bg-background/40 text-muted-foreground transition-colors hover:text-primary"
                aria-label="ERIDON Telegram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
              </a>
            </div>
          </div>

          {/* Контакты */}
          <div>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-foreground/80">
              Контакты
            </h3>
            <p className="text-xs text-muted-foreground">
              Тел:{" "}
              <a href="tel:+79015782213" className="hover:text-primary transition-colors">
                +7 (901) 578-22-13
              </a>
            </p>
            <p className="mt-1 text-xs text-muted-foreground">
              Email:{" "}
              <a
                href="mailto:eridonai@eridonai.online"
                className="hover:text-primary transition-colors"
              >
                eridonai@eridonai.online
              </a>
            </p>
            <p className="mt-1 text-xs text-muted-foreground">
              Сайт:{" "}
              <a href="https://eridonai.ru" className="hover:text-primary transition-colors">
                eridonai.ru
              </a>
            </p>
          </div>

          {/* Юридическая информация */}
          <div>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-wider text-foreground/80">
              Юридическая информация
            </h3>
            <div
              className="space-y-1 rounded-lg border border-border/40 bg-background/40 p-3 text-[11px] leading-relaxed text-muted-foreground"
              style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
            >
              <p>
                <span className="text-foreground/70">ИП</span> Демкин Александр Денисович
              </p>
              <p>
                <span className="text-foreground/70">ИНН:</span> 500122938292
              </p>
              <p>
                <span className="text-foreground/70">ОГРНИП:</span> 326508100244366
              </p>
              <p>
                <span className="text-foreground/70">ОКВЭД:</span> 62.01
              </p>
            </div>
          </div>
        </div>

        {/* Юридические ссылки — обязательны для документов и банковской отчётности */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 border-t border-border/30 pt-5 text-xs">
          <Link to="/documents" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Документы
          </Link>
          <Link to="/offer" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Публичная оферта
          </Link>
          <Link to="/privacy" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Политика конфиденциальности
          </Link>
          <Link to="/data-policy" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Обработка персональных данных
          </Link>
          <Link to="/refund" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Правила возврата
          </Link>
          <Link to="/contacts" className="text-foreground/80 underline-offset-4 hover:text-primary hover:underline">
            Контакты
          </Link>
        </div>

        {/* Copyright */}
        <div className="pt-2 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} ERIDON — ИИ-автоматизация маркировки.{" "}
          <span className="text-muted-foreground">Все права защищены.</span>
        </div>
      </div>
    </footer>
  );
}
